// used for route matching in SiteService
export const proRoutes = [
  '/feed',
  '/images',
  '/videos',
  '/articles',
  '/groups',
  '/login',
  '/forgot-password',
  '/newsfeed',
  '/media',
  '/blog',
  '/all',
];
